var PageService = require('services/page-service');
var utils = require('lib/utils');
var CourseSettingsService = require('services/course-settings-service');
import { LocalStorageService } from 'services/web-storage-service';

var NavigationService = {
  initialize: function () {
    Chaplin.mediator.subscribe('page:navigate', this.navigatePage, this);
    Chaplin.mediator.subscribe('window:navigate', this.navigateWindow, this);
  },

  navigatePage: function (destination) {
    //TODO: figure out another/better way of managing this information
    // pageNavigation posts what the current page is and what
    // the intended destination is to a globally accessible value
    var page;
    if (destination === 'skip') {
      destination = this.direction || 'forward';
    }

    this.direction = null;
    switch (destination) {
      //TODO: not sure this logic is complete - need to discuss more scenarios
      case 'back':
        this.direction = 'back';
        page = PageService.getPreviousPage();
        if (!page && CourseSettingsService.get('menu').allowModuleBack) {
          // if first page in a module, let's go back to prev module
          var currentModuleId = EF.module.id;
          var currentModuleIdx = EF.modules.models
            .map(function (x) {
              return x.id;
            })
            .indexOf(currentModuleId);
          if (currentModuleIdx === 0 && CourseSettingsService.get('menu').skip) {
            // if it is a first page in first module and menu is disabled, let's exit the course
            window.parent.postMessage({ event_type: 'close-content' }, window.location.origin);
            return;
          } else if (currentModuleIdx > 0) {
            let prevModule = EF.modules.models[currentModuleIdx - 1];
            let prevModuleLastActivity = prevModule.activities.models.slice(-1)[0];
            let prevModuleLastPage = prevModuleLastActivity.pages.models.slice(-1)[0];
            PageService.loadPage(prevModule.id, prevModuleLastActivity.id, prevModuleLastPage.id);
            page = prevModuleLastPage;
          }
        }
        break;
      case 'forward':
        this.direction = 'forward';
        page = PageService.getNextPage();
        if (!page && CourseSettingsService.get('menu').skip) {
          // if last page in a module, let's go to the first page of the next module
          const currentModuleIdx = EF.modules.indexOf(EF.module);
          const nextModule = EF.modules.at(currentModuleIdx + 1);
          const currentModuleLastActivity = EF.module.activities.at(EF.module.activities.length - 1);
          const currentModuleLastPage = currentModuleLastActivity.pages.at(currentModuleLastActivity.pages.length - 1);
          const islastPage = currentModuleLastPage.id === EF.module.currentActivity.currentPage.id;
          if (nextModule && islastPage) {
            const nextModuleFirstActivity = nextModule.activities.at(0);
            const nextModuleFirstPage = nextModuleFirstActivity.pages.at(0);
            PageService.loadPage(nextModule.id, nextModuleFirstActivity.id, nextModuleFirstPage.id);
            page = nextModuleFirstPage;
          }
        }
        break;
      case 'home':
        page = null;
        break;
      default:
        page = PageService.getPageByKey(destination);
    }

    EF.module.currentActivity.originPage = EF.module.currentActivity.currentPage.get('key');
    EF.module.currentActivity.destinationPage = page ? page.get('key') : null;

    var currPage = EF.module.currentActivity.currentPage;
    if (currPage && (currPage.get('transition') || CourseSettingsService.get('transitionAll'))) {
      currPage.set('transition-out', destination === 'back' ? 'back' : 'forward');
      //console.log(`navigating away from ${currPage.get('key')}; setting transition-out to ${currPage.get('transition-out')}`);
    }

    if (page && (page.get('transition') || CourseSettingsService.get('transitionAll'))) {
      page.set('transition-in', destination === 'back' ? 'back' : 'forward');
      //console.log(`navigating to ${page.get('key')}; setting transition-in to ${page.get('transition-in')}`);
    }

    var navigate = function () {
      if (page) {
        utils.redirectToPage(page);
      } else {
        if (EF.module && CourseSettingsService.get('menu').type == 'group') {
          var group = EF.groups.find(function (group) {
            return group.get('id') === EF.module.get('group');
          });
          utils.redirectTo('controllers/menu#show', { type: group.get('key') });
        } else {
          utils.redirectTo('controllers/menu#show');
        }
      }
    };

    //console.log('publishing action:unload in navigation-service');
    if (page && page.get('transition-in')) {
      Chaplin.mediator.once('page:state:unloaded', navigate);
      Chaplin.mediator.publish('action:unload');
    } else {
      navigate();
    }
  },

  navigateWindow: function (destination) {
    console.log('Navigating Window', destination);
    window.location.assign(destination);
  },

  reload: function () {
    Backbone.history.stop(); // will be restarted by controllers/reload-controller
    LocalStorageService.setItem('originFragment', Backbone.history.fragment);
    Chaplin.utils.redirectTo({ url: 'reload' });
  },
};

module.exports = NavigationService;
